import { Icon } from 'semantic-ui-react';
import CenterCell from './table/CenterCell';

function PassFailResult({ passed, skipped }) {
	const name  = Number(passed) === 1 ? "check" : (Number(skipped) === 1 ? "warning circle" : "cancel");
	const color = Number(passed) === 1 ? "green" : (Number(skipped) === 1 ? "yellow" : "red");

	return <CenterCell><Icon name={name} color={color} /></CenterCell>
}

export default PassFailResult;
